import { render } from "./LeagueRankingView.vue?vue&type=template&id=0e07a83f&scoped=true"
import script from "./LeagueRankingView.vue?vue&type=script&lang=js"
export * from "./LeagueRankingView.vue?vue&type=script&lang=js"

import "./LeagueRankingView.vue?vue&type=style&index=0&id=0e07a83f&lang=scss"
import "./LeagueRankingView.vue?vue&type=style&index=1&id=0e07a83f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e07a83f"]])

export default __exports__